import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

/**
 * Production: no token → /login.
 * Playwright local webServer sets REACT_APP_E2E_BYPASS_AUTH=1 so shell smoke tests can run without JWT.
 */
const PrivateRoute = ({ children }) => {
  const { token } = useAuth();
  if (process.env.REACT_APP_E2E_BYPASS_AUTH === "1") {
    return children;
  }
  return token ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;